import { render, staticRenderFns } from "./BookingRoutesYangMing.vue?vue&type=template&id=7e90b8fb&scoped=true&"
import script from "./BookingRoutesYangMing.vue?vue&type=script&lang=js&"
export * from "./BookingRoutesYangMing.vue?vue&type=script&lang=js&"
import style0 from "./BookingRoutesYangMing.vue?vue&type=style&index=0&id=7e90b8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90b8fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e90b8fb')) {
      api.createRecord('7e90b8fb', component.options)
    } else {
      api.reload('7e90b8fb', component.options)
    }
    module.hot.accept("./BookingRoutesYangMing.vue?vue&type=template&id=7e90b8fb&scoped=true&", function () {
      api.rerender('7e90b8fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingRoutesYangMing.vue"
export default component.exports